import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import { i18n, Utils, NumberFormatter, DateFormatter } from 'arm-common';
import AppActions from '../../app/app_actions';
import ImpostazioniActions from './impostazioni_actions'
import CheckItem from './CheckItem.jsx';



class ImpostazioniHome extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ImpostazioniHome.jsx] ';

        this.statusPassed = this.statusPassed.bind(this);
    }


    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');
        this.props.getInfo();
    }

    statusPassed() {
        let result = true;

        for (var i = 0; i < this.props.info.length; i++) {
            if (this.props.info[i].status !== "Passed") {
                result = false;
                break;
            }
        }

        return result;
    }

    render() {
        console.log(this.componentName + 'render');

        if (this.props.info === null) {
            return null;
        }

        return (
            <div className="card">
                <div className="card-header">
                    <h1> {i18n('ARM_CORE_PRODUCT.IMPOSTAZIONI.IMPOSTAZIONI', 'Impostazioni')}
                        {this.statusPassed() === true ? <i class="far fa-check-circle" style={{ marginLeft: '15px', color: 'green' }}></i> :
                            <i class="fas fa-exclamation-circle" style={{ color: '#c11111', marginLeft: '15px' }}></i>}
                    </h1>
                </div>
                <div className="card-body">

                    <div className="list-group">
                        {this.props.info.map((item, index) =>
                            <CheckItem item={item} />
                        )
                        }
                    </div>

                </div>
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getLastSchemaDati() {
            return dispatch(ImpostazioniActions.getLastSchemaDati());
        },

        getInfo() {
            return dispatch(ImpostazioniActions.getInfo());
        },


    }
};

function mapStateToProps(state) {
    return {
        lastSchemaDati: state.impostazioni.lastSchemaDati,
        info: state.impostazioni.info
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ImpostazioniHome);
